import React from 'react';
import { Flex, Shimmer } from '@zeal/web-ui';

export function NotificationSkeleton() {
	return (
		<Flex
			isColumn
			gap="2"
			className="py-4 px-5 border-b border-solid border-divider-default bg-surface-default hover:bg-surface-subdued"
		>
			<Flex gap="2" align="center" justify="between">
				<Flex gap="2">
					<Shimmer style={{ height: '20px', width: '170px' }} />
					<Shimmer style={{ height: '20px', width: '54px' }} />
				</Flex>
				<Shimmer style={{ height: '8px', width: '8px' }} />
			</Flex>
			<Flex isColumn gap="1">
				<Shimmer style={{ height: '16.8px', width: '100%' }} />
				<Shimmer style={{ height: '16.8px', width: '80%' }} />
			</Flex>
			<Shimmer style={{ height: '16.8px', width: '100px' }} />
		</Flex>
	);
}
